<template>
    <div ref="container" class="container">

            <header class="text-center pt-4" style="z-index: 100;">
                <h1>{{ $t('translations.404_not_found')}}</h1>
                <p>{{ $t('translations.page_not_found')}}</p>
            </header>

            <div class='card-default'>
                {{ $t("translations.im_sorry_we_cant_find_the_page_you_are_looking_for")}}.
            </div>

            <footer class="container">

            </footer>

    </div><!--ref:container-->


</template>

<script>
var moment = require('moment');
export default {
    props: [
    ],
    data: function(){
        return {
        }
    },
    mounted() {
    },
    computed: {

    },
    methods: {

    }
}
</script>
